<template>
    <q-page class="q-pa-md">

        <q-dialog v-model="dialogDetalles" persistent full-width>
            <q-card>
                <q-bar class="bg-primary text-white">
                    <q-icon color="white" name="mdi-account" />
                    <div>Detalles</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-splitter v-model="splitterModel" :limits="[25, 75]">
                    <template v-slot:before>
                        <q-card class="q-pa-md full-height">
                            <q-card-section>

                                <!-- <q-item v-ripple v-for="a in listaEquipos" :key="a.nombre">
                                            <q-item-section avatar>
                                                <q-icon color="primary" name="mdi-hospital-box" />
                                            </q-item-section>
                                            <q-item-section>
                                                <q-item-label lines="1">{{ a.nombre }}</q-item-label>
                                                <q-item-label caption>
                                                    <q-chip color="primary" outline text-color="primary">
                                                        Marca: {{ a.marca }}
                                                    </q-chip>
                                                    <q-chip outline color="primary" text-color="white">
                                                        Modelo: {{ a.modelo }}
                                                    </q-chip>
                                                    <q-chip outline color="primary" text-color="white">
                                                        Serie: {{ a.serie }}
                                                    </q-chip>
                                                    <q-chip outline color="primary" text-color="white">
                                                        Tipo: {{ a.tipo }}
                                                    </q-chip>
                                                    <q-chip outline color="primary" text-color="white">
                                                        Ubicación: {{ a.tipo }}
                                                    </q-chip>
                                                </q-item-label>
                                            </q-item-section>
                                            <q-item-section side>
                                                <q-icon name="mdi-check-circle" class="text-primary"
                                                    style="font-size: 32px;" />
                                            </q-item-section>
                                        </q-item> -->
                                <q-table separator="cell" title="Equipos" dense :data="listaEquipos"
                                    :columns="columnsEquipos" row-key="name" :rows-per-page-options="[0]" hide-bottom
                                    class="my-sticky-header-table">
                                    <template v-slot:body="props">
                                        <q-tr :props="props">

                                            <q-td key="nunidad" :props="props">
                                                {{ props.row.nunidad }}
                                            </q-td>
                                            <q-td key="nombre" :props="props">
                                                {{ props.row.nombre }}
                                            </q-td>
                                            <q-td key="marca" :props="props">
                                                {{ props.row.marca }}
                                            </q-td>
                                            <q-td key="modelo" :props="props">
                                                {{ props.row.modelo }}
                                            </q-td>
                                            <q-td key="serie" :props="props">
                                                {{ props.row.serie }}
                                            </q-td>
                                            <q-td key="tipo" :props="props">
                                                {{ props.row.tipo }}
                                            </q-td>
                                            <q-td key="ubicacion" :props="props">
                                                {{ props.row.ubicacion }}
                                            </q-td>
                                            <q-td key="funcionalidad" :props="props">
                                                {{ props.row.funcionalidad }}
                                            </q-td>
                                            <q-td auto-width key="acciones" align="center">
                                                <q-icon name="mdi-check-circle" class="text-primary"
                                                    style="font-size: 32px;" />
                                            </q-td>
                                        </q-tr>
                                    </template>
                                </q-table>
                            </q-card-section>
                        </q-card>
                    </template>

                    <template v-slot:after>
                        <q-card class="q-pa-md full-height">
                            <q-card-section>
                                <q-table separator="cell" title="Mobiliario" dense :data="listaMobiliario"
                                    :columns="columnsMobiliario" row-key="name" :rows-per-page-options="[0]" hide-bottom
                                    class="my-sticky-header-table">
                                    <template v-slot:body="props">
                                        <q-tr :props="props">

                                            <q-td key="nunidad" :props="props">
                                                {{ props.row.nunidad }}
                                            </q-td>
                                            <q-td key="nombre" :props="props">
                                                {{ props.row.nombre }}
                                            </q-td>
                                            <q-td key="estado" :props="props">
                                                {{ props.row.estado }}
                                            </q-td>
                                            <q-td key="tipo" :props="props">
                                                {{ props.row.tipo }}
                                            </q-td>
                                            <q-td key="ubicacion" :props="props">
                                                {{ props.row.ubicacion }}
                                            </q-td>
                                            <q-td key="cantidad" :props="props">
                                                {{ props.row.cantidad }}
                                            </q-td>
                                            <q-td auto-width key="acciones" align="center" :props="props">
                                                <q-icon v-if="props.row.existe == 'Si'" name="mdi-check-circle"
                                                    class="text-primary" style="font-size: 32px;" />
                                                <q-icon v-if="props.row.existe == 'No'" name="mdi-alpha-x-circle"
                                                    class="text-red-6" style="font-size: 32px;" />
                                            </q-td>
                                        </q-tr>
                                    </template>
                                </q-table>
                                <!-- <q-toolbar class=" text-primary shadow-1">
                                    <q-toolbar-title>Mobiliario</q-toolbar-title>
                                </q-toolbar>
                                <q-list bordered separator>
                                    <q-scroll-area :thumb-style="thumbStyle" style="height: 500px; ">

                                        <q-item clickable v-ripple active v-for="a in listaMobiliario" :key="a.nombre"
                                            @click="GetDetalleSalasQuirofanos(a)">
                                            <q-item-section avatar>
                                                <q-icon name="mdi-hospital-box" />
                                            </q-item-section>
                                            <q-item-section>
                                                <q-item-label lines="1">{{ a.nombre }}</q-item-label>
                                                <q-item-label caption>
                                                    <q-chip color="primary" outline text-color="primary">
                                                        Tipo: {{ a.tipo }}
                                                    </q-chip>
                                                    <q-chip color="primary" outline text-color="primary">
                                                        Estado: {{ a.estado }}
                                                    </q-chip>
                                                    <q-chip color="primary" outline text-color="primary">
                                                        Estado: {{ a.estado }}
                                                    </q-chip>
                                                    <q-chip color="primary" outline text-color="primary">
                                                        Ubicación: {{ a.ubicacion }}
                                                    </q-chip>
                                                    <q-chip color="primary" outline text-color="primary">
                                                        Cantidad: {{ a.cantidad }}
                                                    </q-chip>
                                                </q-item-label>
                                            </q-item-section>

                                            <q-item-section side>
                                                <q-icon v-if="a.existe == 'Si'" name="mdi-check-circle"
                                                    class="text-primary" style="font-size: 32px;" />
                                                <q-icon v-if="a.existe == 'No'" name="mdi-alpha-x-circle"
                                                    class="text-red-6" style="font-size: 32px;" />
                                            </q-item-section>
                                        </q-item>
                                    </q-scroll-area>
                                </q-list> -->
                            </q-card-section>
                        </q-card>
                    </template>

                </q-splitter>
            </q-card>
        </q-dialog>

        <q-card class="q-pa-md  q-mt-md">
            <div class="row q-col-gutter-md ">
                <div class="col-12 q-px-xl q-ma-md">
                    <q-select dense bg-color="white" outlined v-model="item" option-label="nombre_unidad"
                        :options="data" label="Nombre de la Unidad" color="teal"
                        options-selected-class="text-deep-orange">
                        <template v-slot:option="scope">
                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                <q-item-section avatar>
                                    <q-icon name="mdi-hospital-building" />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label v-html="scope.opt.nombre_unidad" />
                                    <q-item-label caption>{{
                                        scope.opt.nombre_sede + ", " + scope.opt.nombre_tipo_unidad
                                        }}</q-item-label>
                                </q-item-section>
                            </q-item>
                        </template>
                        <template v-slot:after>
                            <q-btn color="primary" icon="mdi-magnify" round @click="GetSalasQuirofanos()" />
                        </template>
                    </q-select>
                </div>
            </div>
        </q-card>

        <q-splitter v-model="splitterModel" class="q-mt-md" :limits="[25, 75]" style="height: 100%">
            <template v-slot:before>
                <q-card class="q-pa-md full-height">
                    <q-card-section>
                        <div class="text-h4 q-mb-md text-center">Quirófanos</div>
                        <q-list bordered separator>
                            <q-item clickable v-ripple active v-for="a in listaQuirofanos" :key="a.nombre"
                                @click="GetDetalleSalasQuirofanos(a)">
                                <q-item-section avatar>
                                    <q-icon name="mdi-hospital-box" />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label lines="1">{{ a.nombre }}</q-item-label>
                                    <q-item-label caption>{{ a.tipo }}</q-item-label>
                                </q-item-section>
                                <q-item-section side>{{ a.num }}</q-item-section>
                            </q-item>
                        </q-list>
                    </q-card-section>
                </q-card>
            </template>

            <template v-slot:after>
                <q-card class="q-pa-md full-height">
                    <q-card-section>
                        <div class="text-h4 q-mb-md text-center">Salas</div>
                        <q-list bordered separator>
                            <q-item clickable v-ripple active v-for="a in listaSalas" :key="a.nombre"
                                @click="GetDetalleSalasQuirofanos(a)">
                                <q-item-section avatar>
                                    <q-icon name="mdi-hospital-box" />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label lines="1">{{ a.nombre }}</q-item-label>
                                    <q-item-label caption>{{ a.tipo }}</q-item-label>
                                </q-item-section>
                                <q-item-section side>{{ a.num }}</q-item-section>
                            </q-item>
                        </q-list>
                    </q-card-section>
                </q-card>
            </template>

        </q-splitter>

    </q-page>
</template>
<script>
import axios from 'axios'
import { date, QSpinnerFacebook } from 'quasar'
import { format } from 'date-fns';

export default {
    components: {
    },
    data() {
        return {
            splitterModel: 50,
            item: {
                nombre_sede: "",
                nombre_tipo_unidad: "",
                nombre_unidad: "",
            },
            loading: false,
            data: [],
            listaQuirofanos: [],
            listaSalas: [],
            dialogDetalles: false,
            listaEquipos: [],
            listaMobiliario: [],


            thumbStyle: {
                right: '2px',
                borderRadius: '5px',
                backgroundColor: '#027be3',
                width: '5px',
                opacity: 0.75
            },

            columnsEquipos: [
                { name: 'nunidad', align: 'center', label: 'Unidad', field: 'nunidad', sortable: true },
                { name: 'nombre', align: 'center', label: 'Nombre', field: 'nombre', sortable: true },
                { name: 'marca', align: 'center', label: 'Marca', field: 'marca', sortable: true },
                { name: 'modelo', align: 'center', label: 'Modelo', field: 'modelo', sortable: true },
                { name: 'serie', align: 'center', label: 'Series', field: 'serie', sortable: true },
                { name: 'tipo', align: 'center', label: 'Tipo', field: 'tipo', sortable: true },
                { name: 'ubicacion', align: 'center', label: 'Ubicación', field: 'ubicacion', sortable: true },
                { name: 'funcionalidad', align: 'center', label: 'Funcionalidad', field: 'funcionalidad', sortable: true },
                { name: 'acciones', align: 'center', label: ' ', field: 'acciones', sortable: true },
            ],
            columnsMobiliario: [
                { name: 'nunidad', align: 'center', label: 'Unidad', field: 'nunidad', sortable: true },
                { name: 'nombre', align: 'center', label: 'Nombre', field: 'nombre', sortable: true },
                { name: 'estado', align: 'center', label: 'Estado', field: 'estado', sortable: true },
                { name: 'tipo', align: 'center', label: 'Tipo', field: 'tipo', sortable: true },
                { name: 'ubicacion', align: 'center', label: 'Ubicación', field: 'ubicacion', sortable: true },
                { name: 'cantidad', align: 'center', label: 'Cantidad', field: 'cantidad', sortable: true },
                { name: 'acciones', align: 'center', label: ' ', field: 'acciones', sortable: true },
            ],
        }
    },
    computed: {
        usuarioStore() {
            return this.$store.state.usuario;
        },
    },
    created() {
        this.GetTablas();
    },
    methods: {
        async GetSalasQuirofanos() {

            let objeto = {
                bd_estado: this.item.bd_estado,
                tabla_unidad: this.item.tabla_unidad
            }
            console.log(this.item)
            try {
                let response = await axios.post('Movil/GetSalasQuirofanos', objeto)
                console.log(response.data.lista)
                let lista = response.data.lista
                this.listaQuirofanos = lista.filter(x => x.tipo == "Quirofano");
                this.listaSalas = lista.filter(x => x.tipo == "Sala");

            } catch (error) {
                console.log(error)
            }
        },
        async GetTablas() {
            this.loading = true;
            try {
                let respuesa = await axios.get(
                    "Configuracion/GetTablas/" + this.usuarioStore.baseDatos
                );
                console.log(respuesa);
                this.loading = false;
                this.data = respuesa.data;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        },

        async GetDetalleSalasQuirofanos(item) {
            let objeto = {
                basedatos: this.item.bd_estado,
                id_unidadcheck: this.item.tabla_unidad,
                nunidad: item.nombre
            }
            console.log(objeto)
            try {
                let response = await axios.post('Movil/GetDetalleSalasQuirofanos', objeto)
                console.log(response.data)
                this.listaEquipos = response.data.listaEquipos
                this.listaMobiliario = response.data.listamobiliario
                this.dialogDetalles = true
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>
<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  max-height: 500px

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: #fff

  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>